export default "__VITE_ASSET__B5yf4ztH__"